import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductDataForSwift } from '../../../../model/finzy-flex/product-list.model';

@Component({
  selector: 'app-view-swift-allocation',
  templateUrl: './view-swift-allocation.component.html',
  styleUrls: ['./view-swift-allocation.component.css']
})
export class ViewSwiftAllocationComponent implements OnInit {

  private matDialogRef: MatDialogRef<ViewSwiftAllocationComponent>;
  public productsDataForSwift: ProductDataForSwift[] = [];

  constructor(
    matDialogRef: MatDialogRef<ViewSwiftAllocationComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.matDialogRef = matDialogRef;
    this.productsDataForSwift = data.productData;
   }

  ngOnInit(): void {
  }
  onClickBack() {
    return this.matDialogRef.close();
  }

}
